module.exports = __webpack_public_path__ + "static/media/justine_logo.2f856060.svg";